import React from 'react';

const FormField = ({
  label,
  id,
  type = 'text',
  value = '',
  onChange,
  required,
  maxLength,
  options,
  error,
  placeholder
}) => {
  // Get the appropriate class name based on field type
  const getClassName = () => {
    const baseClass = 'form-control';
    const errorClass = error ? 'error' : '';
    
    switch (type) {
      case 'dropdown':
        return `${baseClass} form-select ${errorClass}`.trim();
      case 'textarea':
        return `${baseClass} form-textarea ${errorClass}`.trim();
      default:
        return `${baseClass} ${errorClass}`.trim();
    }
  };

  // Common props for all input types
  const commonProps = {
    id,
    value,
    onChange,
    required,
    placeholder,
    className: getClassName(),
    'aria-invalid': error ? 'true' : 'false'
  };

  // Render the appropriate input element
  const renderField = () => {
    switch (type) {
      case 'dropdown':
        return (
          <select {...commonProps}>
            <option value="">{placeholder || 'Select an option'}</option>
            {options?.map((option, index) => (
              <option key={index} value={option}>{option}</option>
            ))}
          </select>
        );
      case 'textarea':
        return <textarea {...commonProps} maxLength={maxLength} />;
      default:
        return <input {...commonProps} type={type} maxLength={maxLength} />;
    }
  };

  return (
    <div className="form-group">
      <label htmlFor={id} className="form-label">
        {label} {required && <span>*</span>}
      </label>
      {renderField()}
      {maxLength && (
        <div className="form-counter">
          {value.length}/{maxLength} characters
        </div>
      )}
      {error && <div className="form-error" role="alert">{error}</div>}
    </div>
  );
};

export default FormField;